import {
    FETCH_ATTENDANCE_REQUEST,
    FETCH_ATTENDANCE_SUCCESS,
    FETCH_ATTENDANCE_FAILURE
} from './actionTypes';

const initialState={
    attendance:{data:[]},
    loading:false,
    error:null
}

const attendanceReducer=(state=initialState,action)=>{
    switch(action.type){
        case FETCH_ATTENDANCE_REQUEST:
            return{
                ...state,
                loading:true,
                error:null
            };
            case FETCH_ATTENDANCE_SUCCESS:
              return {
                ...state,
                loading: false,
                attendance: action.payload || { data: [] },
              };
            case FETCH_ATTENDANCE_FAILURE:
                  return {
                    ...state,
                    loading: false,
                    error: action.payload,
                  };

                default:
                    return state;
    }
}

export default attendanceReducer;